import React from 'react';

interface TelegramModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const TelegramModal: React.FC<TelegramModalProps> = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${isOpen ? 'show' : ''}`}>
      <div className={`modal-content ${isOpen ? 'show' : ''}`}>
        <div className="modal-content-inner">
          <h3>Join Our Community First!</h3>
          <p>
            Before getting started, we recommend joining our Telegram channel to stay updated with our launch and community events.
          </p>
          <div className="modal-buttons">
            <button className="modal-cancel" onClick={onClose}>
              Cancel
            </button>
            <button className="modal-confirm" onClick={onConfirm}>
              Join Telegram & Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TelegramModal;
